import API from "../api/axios";

// ─── Login User ───
export const loginUser = (data) => {
   return API.post("/login", data);
};

// ─── Register User ───
export const registerUser = (data) => {
   return API.post("/register", data);
};

// ─── Forgot Password ───
export const forgotPassword = (data) => {
   return API.post("/forgot-password", data);
};